import _ from 'lodash'
import { safeAwait } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import {
  fetchS3Wssid,
  fetchTempCredential,
  fetchS3Object
} from '../actions/serviceActions/common'
import { delay } from '../../lib/renderUtil'
import { throwIfError } from '../lib/reserviceErrorHelpers'
import useReservice from './useReservice'
import useS3Upload from './useS3Upload'

const useClientS3Upload = (
  fetcher,
  customValidations,
  customUploadedImageName
) => {
  const { reservice } = useReservice(fetcher)

  const getWssId = async (retry = 1) => {
    const [fetchError, res] = await safeAwait(reservice(fetchS3Wssid()))
    if (
      (!res || res.error || _.isEmpty(res.payload)) && retry < 3
    ) {
      await delay(500)
      return getWssId(retry + 1)
    }
    const errors = { httpError: fetchError, reserviceError: res }
    throwIfError(errors, `取得S3 wssid時失敗，重試${retry}次逾時`)

    return res.payload
  }

  const getCredentials = async (retry = 1) => {
    const [fetchError, res] = await safeAwait(reservice(fetchTempCredential()))
    if (
      (!res || res.error || _.isEmpty(res.payload)) && retry < 3
    ) {
      await delay(2000)
      return getCredentials(retry + 1)
    }
    const errors = { httpError: fetchError, reserviceError: res }
    throwIfError(errors, `取得S3憑證時失敗，重試${retry}次逾時`)

    const tempCredential = res.payload
    return {
      accessKeyId: tempCredential.id,
      secretAccessKey: tempCredential.key,
      sessionToken: tempCredential.token
    }
  }

  const transformS3Object = async (s3FileInfo, file) => {
    const { ETag } = s3FileInfo
    const fetchS3ObjectPayload = async (id, retry = 1) => {
      const retryCount = 30
      const [fetchError, res] = await safeAwait(reservice(fetchS3Object({ id })))
      if (
        (!res || res.error || _.isEmpty(res.payload)) && retry < retryCount
      ) {
        const error = _.get(res, 'payload.errorData.error[0]', {})
        const { code, message: errorMessage } = error
        const allowRetry = code === 4040001
        if (errorMessage && !allowRetry) {
          const errors = { reserviceError: res }
          throwIfError(errors, `取得S3連結時失敗，訊息: ${errorMessage}.`)
        }

        await delay(3000)
        return fetchS3ObjectPayload(id, retry + 1)
      }
      const errors = { httpError: fetchError, reserviceError: res }
      throwIfError(errors, `取得S3連結時失敗，重試${retry}次逾時`)

      return res.payload
    }
    const s3Object = await fetchS3ObjectPayload(ETag)
    return _.merge(s3FileInfo, s3Object)
  }

  const actions = {
    getWssId,
    getCredentials,
    transformS3Object
  }

  return useS3Upload(actions, customValidations, customUploadedImageName)
}

export default useClientS3Upload
